import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardText,
  CCol,
  CContainer,
  CImage,
  CRow,
  CAlert,
  CBadge,
} from '@coreui/react'
import { cilSpreadsheet, cilChevronRight, cilLightbulb } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import apiClient from '../../services/apiClient'
import { useNavigate } from 'react-router-dom'
import { isNull } from 'lodash'
import { buildApiUrl } from '../../utils/getConfiguration'
import InternalAppHeader from './components/InternalAppHeader'
import { useTranslation } from 'react-i18next'
import { SplashScreen } from '@capacitor/splash-screen'

const SuppliersInnoProject = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [suppliers, setSuppliers] = useState([])

  const fetchSuppliersData = async () => {
    try {
      const grp_ID = localStorage.getItem('grp_ID')
      const response = await apiClient.get(buildApiUrl('suppliers', { grp_ID }))
      setSuppliers(response.data)
    } catch (error) {
      console.error('Error fetching suppliers', error)
    }
  }

  useEffect(() => {
    fetchSuppliersData()
  }, [])

  const [prefsuppliers, setPrefSuppliers] = useState([])

  const fetchPrefSuppliersData = async () => {
    try {
      const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      const grp_ID = localStorage.getItem('grp_ID')
      const params = { reminder_ID, account_ID, grp_ID }
      console.log('Preferred supplier params', params)
      const response = await apiClient.get(buildApiUrl('supplierPref', params))
      setPrefSuppliers(response.data)
    } catch (error) {
      console.error('Error fetching supplier', error)
    }
  }

  useEffect(() => {
    if (
      String(localStorage.getItem('supplierid')) === 'null' &&
      String(localStorage.getItem('suppliertel')) === 'null'
    ) {
      console.log('Needed supplier')
      setVisible(true)
    } else {
      console.log('Not needed supplier')
      setVisible(false)
    }
    console.log(localStorage.getItem('suppliertel'))
    fetchPrefSuppliersData()
  }, [])

  const [startups, setStartups] = useState([])

  const fetchInnovationsData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const response = await apiClient.get(buildApiUrl('startupsList', { account_ID }))
      setStartups(response.data)
    } catch (error) {
      console.error('Error fetching suppliers', error)
    }
  }

  const hideSplashScreen = useCallback(() => {
    if (typeof window === 'undefined') {
      return
    }

    const splash = document.getElementById('splash-screen')
    if (splash) {
      splash.style.display = 'none'
    }

    if (typeof SplashScreen?.hide === 'function') {
      SplashScreen.hide({ fadeOutDuration: 200 }).catch((error) => {
        console.warn('Unable to hide splash screen in SuppliersInnoProject', error)
      })
    } else if (typeof window.SplashScreen?.hide === 'function') {
      window.SplashScreen.hide({ fadeOutDuration: 200 }).catch((error) => {
        console.warn('Unable to hide splash screen in SuppliersInnoProject', error)
      })
    }
  }, [])

  useEffect(() => {
    fetchInnovationsData().finally(hideSplashScreen)
  }, [hideSplashScreen])

  useEffect(() => {
    hideSplashScreen()
  }, [hideSplashScreen])

  let navigate = useNavigate()

  const handleClickUnassign = async (startup_ID) => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      //console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      //const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      await apiClient.get(
        buildApiUrl('startupUnassign', {
          startup_ID,
          account_ID,
        }),
      )
      //localStorage.setItem('supplierid', 'null')
      //localStorage.setItem('suppliertel', 'null')
      fetchInnovationsData()
      setVisible(true)
      console.log('Unassigned startup ' + startup_ID)
      //localStorage.removeItem('supplierid')
      //window.history.back()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  function mergeTel(str1) {
    return 'tel:' + str1
  }

  const typeLabelMap = useMemo(
    () => ({
      F: t('suppliersInno.types.F'),
      C: t('suppliersInno.types.C'),
      J: t('suppliersInno.types.J'),
    }),
    [t],
  )

  function getIdeaTypeLabel(type) {
    if (isNull(type)) return ''
    return typeLabelMap[type] || ''
  }

  return (
    <div className="buying-list-wrapper min-vh-100 d-flex flex-column">
      <CContainer className="py-4 flex-grow-1">
        <InternalAppHeader
          title={t('suppliersInnoProject.headerTitle')}
          onBack={() => window.history.back()}
        />
        <CRow className="justify-content-center g-0 mt-2">
          <CCol lg={10}>
            <CCard className="mb-4 border-0 shadow-sm">
              <CCardBody className="p-4 p-lg-5 d-flex flex-column gap-3">
                <div className="d-flex justify-content-end align-items-center">
                  <CButton
                    color="primary"
                    className="suppliers-inno__next-btn"
                    onClick={() => {
                      console.log('Saved project description')
                      navigate('/suppliersinnoprojectdescription')
                    }}
                    aria-label={t('suppliersInnoProject.actions.goDescription')}
                  >
                    <CIcon icon={cilChevronRight} />
                  </CButton>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                  <h4 className="mb-0">{t('suppliersInnoProject.sections.summaryTitle')}</h4>
                  <CBadge color="primary">{startups.length}</CBadge>
                </div>
                <hr className="my-2" />
                {startups.length > 0 ? (
                  <CRow className="gy-3">
                    {startups.map((startup, index) => {
                      const ideaTypeLabel = getIdeaTypeLabel(startup.type)
                      const ideaText = Array.isArray(startup.idea)
                        ? startup.idea[0] || ''
                        : startup.idea || ''
                      const trimmedIdeaText = typeof ideaText === 'string' ? ideaText.trim() : ''
                      const hasIdeaText = trimmedIdeaText.length > 0
                      const description =
                        typeof startup.description === 'string' && startup.description.length > 0
                          ? startup.description.substring(0, 140) +
                            (startup.description.length > 140 ? '...' : '')
                          : ''
                      const linkTarget =
                        startup.link && /^https?:\/\//i.test(startup.link)
                          ? startup.link
                          : startup.link
                            ? `https://${startup.link}`
                            : null
                      const pictureSrc = startup.pic
                        ? `https://www.emerkur.eu/startups/${startup.pic}`
                        : null
                      const ideaTitle =
                        typeof startup.idea === 'string' && startup.idea.trim().length > 0
                          ? startup.idea.trim()
                          : typeof startup.company === 'string' &&
                              startup.company?.trim().length > 0
                            ? startup.company.trim()
                            : t('suppliersInno.labels.startupFallback', { id: startup.startup_id })

                      return (
                        <CCol xs={12} key={startup.startup_id}>
                          <CCard className="innovation-priority-card h-100 border-0">
                            <CCardBody className="d-flex flex-column gap-4">
                              <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                                <div className="d-flex align-items-center gap-3">
                                  <CBadge
                                    color="primary"
                                    className="innovation-priority-card__index"
                                  >
                                    #{index + 1}
                                  </CBadge>
                                  <h5 className="mb-0 innovation-priority-card__title">
                                    {ideaTitle}
                                  </h5>
                                </div>
                                {ideaTypeLabel ? (
                                  <CBadge color="info" className="text-uppercase fw-semibold">
                                    {ideaTypeLabel}
                                  </CBadge>
                                ) : (
                                  <CBadge
                                    color="secondary"
                                    className="text-uppercase bg-secondary-subtle text-secondary fw-semibold"
                                  >
                                    {t('suppliersInnoProject.labels.typeUndefined')}
                                  </CBadge>
                                )}
                              </div>
                              <div className="d-flex flex-wrap gap-3 align-items-start">
                                <div className="innovation-priority-card__logo">
                                  {pictureSrc ? (
                                    <CImage
                                      rounded
                                      src={pictureSrc}
                                      alt={`${ideaTitle} logo`}
                                      className="w-100 h-100"
                                      style={{ objectFit: 'contain' }}
                                    />
                                  ) : (
                                    <div className="innovation-priority-card__logo-placeholder">
                                      <CIcon icon={cilLightbulb} size="lg" />
                                    </div>
                                  )}
                                </div>
                                <div className="flex-grow-1 d-flex flex-column gap-2">
                                  {description && (
                                    <CCardText className="mb-0 text-medium-emphasis">
                                      {description}
                                    </CCardText>
                                  )}
                                  {linkTarget && (
                                    <a
                                      href={linkTarget}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="innovation-priority-card__link"
                                      onClick={(e) => {
                                        window.open(linkTarget, '_blank', 'noopener,noreferrer')
                                        e.preventDefault()
                                      }}
                                    >
                                      {startup.link}
                                    </a>
                                  )}
                                </div>
                              </div>
                              <div className="innovation-priority-card__idea">
                                <span className="innovation-priority-card__idea-label">
                                  {t('suppliersInnoProject.labels.ideaLabel')}
                                </span>
                                {hasIdeaText ? (
                                  <CCardText className="mb-0 innovation-priority-card__idea-text">
                                    {trimmedIdeaText}
                                  </CCardText>
                                ) : (
                                  <CCardText className="mb-0 innovation-priority-card__idea-text text-medium-emphasis">
                                    {t('suppliersInnoProject.labels.ideaEmpty')}
                                  </CCardText>
                                )}
                              </div>
                            </CCardBody>
                          </CCard>
                        </CCol>
                      )
                    })}
                  </CRow>
                ) : (
                  <CAlert color="info" className="mb-0">
                    {t('suppliersInnoProject.messages.listEmpty')}
                  </CAlert>
                )}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default SuppliersInnoProject
